import type { Board, Pos, MatchPair } from "./types";
import { boardDims } from "./board";

// 直线连通检测：两个方块要能消除，必须同行或同列，且它们之间没有任何非空格子阻挡。
export function isStraightClear(board: Board, a: Pos, b: Pos): boolean {
  // 既不同行也不同列 → 不是直线，不可能连通
  if (a.x !== b.x && a.y !== b.y) return false;

  if (a.x === b.x) {
    const minY = Math.min(a.y, b.y);
    const maxY = Math.max(a.y, b.y);
    for (let y = minY + 1; y < maxY; y++) {
      if (board[y][a.x] !== null) return false;
    }
    return true;
  }

  const minX = Math.min(a.x, b.x);
  const maxX = Math.max(a.x, b.x);
  for (let x = minX + 1; x < maxX; x++) {
    if (board[a.y][x] !== null) return false;
  }
  return true;
}

// 在棋盘上为 (x,y) 处的 kind 寻找一个可直线消除的同类方块。找不到返回 null。
export function findMatchInBoard(
  board: Board,
  x: number,
  y: number,
  kind: number,
): Pos | null {
  const { w, h } = boardDims(board);
  for (let j = 0; j < h; j++) {
    for (let i = 0; i < w; i++) {
      if (i === x && j === y) continue;
      if (board[j][i] === kind && isStraightClear(board, { x, y }, { x: i, y: j })) {
        return { x: i, y: j };
      }
    }
  }
  return null;
}

// 全盘扫描第一对「直接可消除」的方块（无需滑动）。找不到返回 null。
export function findDirectMatchPair(board: Board): MatchPair | null {
  const { w, h } = boardDims(board);
  for (let y = 0; y < h; y++) {
    for (let x = 0; x < w; x++) {
      const val = board[y][x];
      if (val === null) continue;
      const mate = findMatchInBoard(board, x, y, val);
      if (mate) return { a: { x, y }, b: mate };
    }
  }
  return null;
}
